/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetLocationResponse } from './GetLocationResponse';
import {
    GetLocationResponseFromJSON,
    GetLocationResponseFromJSONTyped,
    GetLocationResponseToJSON,
    GetLocationResponseToJSONTyped,
} from './GetLocationResponse';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetClassRoomResponse
 */
export interface GetClassRoomResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetClassRoomResponse
     */
    classRoomId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof GetClassRoomResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetClassRoomResponse
     */
    description: string | null;
    /**
     * 
     * @type {GetLocationResponse}
     * @memberof GetClassRoomResponse
     */
    location: GetLocationResponse | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetClassRoomResponse
     */
    isActive: boolean;
}

/**
 * Check if a given object implements the GetClassRoomResponse interface.
 */
export function instanceOfGetClassRoomResponse(value: object): value is GetClassRoomResponse {
    if (!('classRoomId' in value) || value['classRoomId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function GetClassRoomResponseFromJSON(json: any): GetClassRoomResponse {
    return GetClassRoomResponseFromJSONTyped(json, false);
}

export function GetClassRoomResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetClassRoomResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'classRoomId': ApiUserTasksGetPageParameterFromJSON(json['classRoomId']),
        'name': json['name'],
        'description': json['description'],
        'location': GetLocationResponseFromJSON(json['location']),
        'isActive': json['isActive'],
    };
}

export function GetClassRoomResponseToJSON(json: any): GetClassRoomResponse {
    return GetClassRoomResponseToJSONTyped(json, false);
}

export function GetClassRoomResponseToJSONTyped(value?: GetClassRoomResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'classRoomId': ApiUserTasksGetPageParameterToJSON(value['classRoomId']),
        'name': value['name'],
        'description': value['description'],
        'location': GetLocationResponseToJSON(value['location']),
        'isActive': value['isActive'],
    };
}

